<div class="contact-permission-detail" *ngIf="contactPermission">
  <div class="group permission-brief">
    <div class="brief-title">
      <span class="title">{{"contact_permission.brief_title" | translate}}</span>
    </div>
    <div class="group-content">
      <div class="group-text">{{"contact_permission.brief_content" | translate:{advertiserName: contactPermission.advertiserName, companyName: contactPermission.agencyName} }}</div>
    </div>
  </div>
</div>
<div class="action-container" *ngIf="!isDeletedOrError">
  <div class="permission-detail-loader" *ngIf="isConfirmingInfluencerNameAndEmail">
    <achoo-loader [normalPlaceholder]="true"></achoo-loader>
  </div>
  <div class="button-group">
    <button class="button decline-btn red" (click)="onDeclinePermission()">{{'common.btn.decline' | translate}}</button>
    <button class="button blue" (click)="onAcceptPermission()">{{acceptButtonLabel}}</button>
  </div>
  <span [innerHTML]="'common.achoo_footer_msg' | translate"></span>
</div>
<div class="decline-warning" *ngIf="showDeclineModal">
  <div class="modal-backdrop show"></div>
  <div class="modal-content" (clickOutside)="clickOutsideDeclineModal($event)">
    <a class="close" data-dismiss="modal" (click)="clickOutsideDeclineModal($event)" aria-label="Close">
      <img src="/assets/images/Add_Icon.svg" class="icon-close-popup">
    </a>
    <influencer-decline-modal (declineEvent)="acceptToDecline($event)"
                              (openContactEvent)="openContact()"
                              (closeModalEvent)="closeDeclineModal()">
    </influencer-decline-modal>
  </div>
</div>
<achoo-popup #ChannelConfirmPopup
             [isSpecialPopup]="true"
             (cancelCallback)="closeNotification()">
  <campaign-acception-popup [channelList]="listExistingChannel"
                            [activePage]="activePageBeforeAuthorizingFb"
                            (confirmChannel)="onConfirmChannel()">
  </campaign-acception-popup>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/contact-permission/contact-permission-detail/contact-permission-detail.component.html